import h from "../../core/createElement";
import popupAlerts from "../../core/popupAlerts";
import ConfirmTypeFileModal from "../../modals/confirm_type_file";
import file_service from "../../service/file_service";
import Box from "../box";
import Btn from "../btn";
import SearchBar from "../search_bar";
import FileList from "./file_list";


export default function FilesListBox({ shared = {}, name = "filelistbox" }) {
    let input_file, report_id;

    const
        inner_shared = {},
        files_btns = [
            <SearchBar placeholder="Pesquisa por nome" shared={inner_shared} name="files_search_bar" onSearch={v => shared.group_id && search_file_by_name(v)} />,
            <Btn shared={inner_shared} name="btn_add_file" color="green" icon="assets/image/plus.svg" onClick={() => new_file()} />
        ];

    const
        fetch_files = (...args) => inner_shared.file_list.fetch_files(...args),
        refresh_files = () => {
            inner_shared.files_search_bar.close();
            return inner_shared.file_list.fetch_files({ report_id }, 1);
        },
        search_file_by_name = (v) => fetch_files({ name: v, report_id }, 1),
        new_file = () => {
            if (!+shared.group_id) return popupAlerts.danger("Crie uma aplicação(grupo) para prosseguir!");
            input_file.click();
        },
        on_change_new_file = (evt) => {
            const file = evt.target.files[0];

            evt.target.value = "";

            ConfirmTypeFileModal.show({
                confirm: async (type) => {
                    const progress_bar = popupAlerts.progress('Fazendo upload...');

                    try {
                        const body = new FormData();

                        body.append('jrxml', file);
                        body.append('type', type);
                        body.append('group_id', shared.group_id);

                        const progress_callback = (evt) => {
                            progress_bar.progress((evt.loaded / evt.total) * 100)
                        };

                        await file_service.upload_file(body, progress_callback);

                        progress_bar.dismiss();

                        popupAlerts.success('Upload concluido!');

                        await refresh_files();
                    } catch (e) {
                        progress_bar.dismiss()
                    };
                }
            });
        },
        hightlight_on_overlay = async (_report_id) => {
            inner_shared.files_box.hightlight_on_overlay();
            inner_shared.btn_add_file.disable();
            inner_shared.files_search_bar.close();
            report_id = _report_id;
            await fetch_files({ report_id }, 1);
        },
        dismiss_hightlight = () => {
            inner_shared.files_box.dismiss_hightlight();
            inner_shared.btn_add_file.enable();
            report_id = null;
            refresh_files();
        };


    shared[name] = {
        fetch_files,
        refresh_files,
        hightlight_on_overlay,
        dismiss_hightlight
    };

    Object.defineProperty(inner_shared, 'group_id', { get: () => shared.group_id });

    return (
        <Box title="Arquivos" shared={inner_shared} name="files_box" containerClass="min-w-450" minimizable={true} minimized={true} buttons={files_btns}>
            {input_file = <input type="file" accept=".jrxml" class="d-none" onChange={on_change_new_file} />}
            <FileList shared={inner_shared} name="file_list" />
        </Box>
    );
};